// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.salesforce-integration-container {
  background: #ffffff;
  min-height: calc(100vh - 64px);
}

.salesforce-header {
  background: #f5f9ff;
  border: 1px solid #e0e6eb;
  border-bottom: 1px solid #d3e1ed;
  padding: 20px 24px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.salesforce-header-left {
  display: flex;
  align-items: center;
  gap: 12px;
}

.back-button {
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.back-button:hover {
  opacity: 0.7;
}

.breadcrumb {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #40a0c1;
  margin-bottom: 0;
}

.breadcrumb-separator {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #142a31;
  margin: 0 8px;
}

.breadcrumb-current {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 16px;
  color: #142a31;
}

.salesforce-info-section {
  margin: 0 24px;
  padding: 30px 0;
  background: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  border-bottom: 1px solid #D3E1ED;
}

.salesforce-info-header {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.salesforce-title-group {
  display: flex;
  align-items: center;
  gap: 20px;
  height: 55.68px;
}

.salesforce-logo-wrapper {
  width: 55.68px;
  height: 55.68px;
  border-radius: 50%;
  box-shadow: 0px 9px 13px 0px rgba(129, 155, 163, 0.12), 0px 0px 3px 0px rgba(20, 43, 49, 0.08);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.salesforce-logo {
  width: 60px;
  height: 60px;
  object-fit: contain;
}

.salesforce-info-content {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-left: 75.68px;
}

.salesforce-title {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 22px;
  line-height: 1.21;
  color: #142a31;
  margin: 0;
}

.salesforce-description {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.21;
  color: #365a64;
  margin: 0;
  max-width: 428px;
}

.salesforce-expiry-label {
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 11px;
  line-height: 1.21;
  color: #365a64;
  margin: 0;
}

.salesforce-info-actions {
  display: flex;
  gap: 12px;
}

.salesforce-integration-section {
  display: flex;
  gap: 12px;
  padding: 41px 24px 24px 24px;
}

.salesforce-install-button {
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 46px;
  min-width: 70px;
  padding: 0px 16px;
  border: 1px solid transparent;
  border-radius: 63px;
  background: #40A0C1;
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  cursor: pointer;
  box-sizing: border-box;
  transition: background-color 160ms ease, transform 60ms ease, box-shadow 160ms ease;
}
.salesforce-install-button > img {
  width: 26px;
  height: 18px;
  object-fit: contain;
}
.salesforce-install-button:hover {
  background: rgb(55.4814229249, 141.3881422925, 170.9185770751);
}
.salesforce-install-button:active {
  background: rgb(47.9826086957, 122.2782608696, 147.8173913043);
  transform: translateY(0.5px);
}
.salesforce-install-button:disabled {
  background: #9ca3af;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/pages/Integrations/SalesforceIntegration/salesforce-integration.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;EACA,8BAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,gCAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,uBAAA;EACA,YAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACF;AACE;EACE,YAAA;AACJ;;AAGA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;AAAF;;AAGA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;AAAF;;AAGA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,cAAA;AAAF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,mBAAA;EACA,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,gCAAA;AADF;;AAIA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AADF;;AAIA;EACE,cAAA;EACA,eAAA;EACA,kBAAA;EACA,8FAAA;EAEA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;AAFF;;AAKA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAFF;;AAKA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,oBAAA;AAFF;;AAKA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAFF;;AAKA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gCAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;AAFF;;AAKA;EACE,aAAA;EACA,SAAA;EACA,4BAAA;AAFF;;AAKA;EACE,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,6BAAA;EACA,mBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,sBAAA;EACA,mFAAA;AAFF;AAIE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AAFJ;AAKE;EACE,8DAAA;AAHJ;AAME;EACE,8DAAA;EACA,4BAAA;AAJJ;AAOE;EACE,mBAAA;EACA,mBAAA;AALJ","sourcesContent":[".salesforce-integration-container {\n  background: #ffffff;\n  min-height: calc(100vh - 64px);\n}\n\n.salesforce-header {\n  background: #f5f9ff;\n  border: 1px solid #e0e6eb;\n  border-bottom: 1px solid #d3e1ed;\n  padding: 20px 24px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.salesforce-header-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.back-button {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  &:hover {\n    opacity: 0.7;\n  }\n}\n\n.breadcrumb {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #40a0c1;\n  margin-bottom: 0;\n}\n\n.breadcrumb-separator {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #142a31;\n  margin: 0 8px;\n}\n\n.breadcrumb-current {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 16px;\n  color: #142a31;\n}\n\n// Integration Info Section\n.salesforce-info-section {\n  margin: 0 24px;\n  padding: 30px 0;\n  background: #ffffff;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  border-bottom: 1px solid #D3E1ED;\n}\n\n.salesforce-info-header {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.salesforce-title-group {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  height: 55.68px;\n}\n\n.salesforce-logo-wrapper {\n  width: 55.68px;\n  height: 55.68px;\n  border-radius: 50%;\n  box-shadow: 0px 9px 13px 0px rgba(129, 155, 163, 0.12),\n    0px 0px 3px 0px rgba(20, 43, 49, 0.08);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.salesforce-logo {\n  width: 60px;\n  height: 60px;\n  object-fit: contain;\n}\n\n.salesforce-info-content {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-left: calc(55.68px + 20px);\n}\n\n.salesforce-title {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 22px;\n  line-height: 1.21;\n  color: #142a31;\n  margin: 0;\n}\n\n.salesforce-description {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0;\n  max-width: 428px;\n}\n\n.salesforce-expiry-label {\n  font-family: \"Inter\", sans-serif;\n  font-weight: 700;\n  font-size: 11px;\n  line-height: 1.21;\n  color: #365a64;\n  margin: 0;\n}\n\n.salesforce-info-actions {\n  display: flex;\n  gap: 12px;\n}\n\n.salesforce-integration-section {\n  display: flex;\n  gap: 12px;\n  padding: 41px 24px 24px 24px;\n}\n\n.salesforce-install-button {\n  appearance: none;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n  height: 46px;\n  min-width: 70px;\n  padding: 0px 16px;\n  border: 1px solid transparent;\n  border-radius: 63px;\n  background: #40A0C1;\n  color: #ffffff;\n  font-weight: 600;\n  font-size: 14px;\n  cursor: pointer;\n  box-sizing: border-box;\n  transition: background-color 160ms ease, transform 60ms ease, box-shadow 160ms ease;\n\n  & > img {\n    width: 26px;\n    height: 18px;\n    object-fit: contain;\n  }\n\n  &:hover {\n    background: darken(#40A0C1, 6%);\n  }\n\n  &:active {\n    background: darken(#40A0C1, 12%);\n    transform: translateY(0.5px);\n  }\n\n  &:disabled {\n    background: #9ca3af;\n    cursor: not-allowed;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
